import { Injectable } from '@angular/core';
import { UserManager, UserManagerSettings } from "./user-manager";
import { UserApiService, UserClaim, UserDetailsResponse } from "../../shared/service-proxies/service-proxies";
import { Router } from '@angular/router';
import { from, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public static userManagerSettings: UserManagerSettings = {
    loginUrl: "/Account/Login",
    loginOutUrl: "/Account/Logout"
  }
  private _manager: UserManager;
  private securityObject: UserDetailsResponse = null;

  constructor(private userApiService: UserApiService, private router: Router) {
    this._manager = new UserManager(AuthService.userManagerSettings, userApiService);
    this.securityObject = null;

    if (sessionStorage.getItem("user")) {
      this.securityObject = JSON.parse(sessionStorage.getItem("user"));
    } else {
      sessionStorage.setItem("user", JSON.stringify(this.securityObject));
    }
  }

  isSignedIn(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._manager.getUser().then(user => {
        if (user == null) {
          this._manager.getUserDetails().then(user => {
            if(user !== null) {
              this.securityObject = user;
              sessionStorage.setItem("userClaims", JSON.stringify(user.userClaims));
            }
            resolve(user !== null);
          })
        } else {
          resolve(true)
        }
      }).catch(reason => {
        resolve(false);
      });
    });
  }

  isAdmin(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._manager.getUser().then(user => {
        this.securityObject = user;
        if (user !== null) {
          resolve(user.isAdmin)
        } else {
          resolve(false);
        }
      });
    });
  }

  hasClaimPromise(claimType: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._manager.getUserDetails().then(user => {
        this.securityObject = user;
        resolve(this.isClaimValid(claimType))
      });
    });
  }

  isHeadOfficeUser(): boolean {
    return this.securityObject == null ? false : this.securityObject.isHeadOfficeUser;
  }

  isFinanceUser(): boolean {
    return this.securityObject == null ? false : this.securityObject.isFinanceUser;
  }

  userHasClaim(claimType: string, claimValue?: string): boolean {
    let ret = false;
    if (typeof claimType === "string") {
      ret = this.isClaimValid(claimType, claimValue);
    } else {
      const claims: string[] = claimType;

      if (claims) {
        for (let index = 0; index < claims.length; index++) {
          ret = this.isClaimValid(claims[index]);
          if (ret) {
            break;
          }
        }
      }
    }

    return ret;
  }

  hasClaim(claimType: any, claimValue?: any): Observable<boolean> {
    if (this.securityObject == null) {
      return from(this.hasClaimPromise(claimType));
    } else {
      let ret = false;
      if (typeof claimType === "string") {
        ret = this.isClaimValid(claimType, claimValue);
      } else {
        const claims: string[] = claimType;

        if (claims) {
          for (let index = 0; index < claims.length; index++) {
            ret = this.isClaimValid(claims[index]);
            if (ret) {
              break;
            }
          }
        }
      }

      return of(ret);
    }
  }

  getRole(): string {
    return this.securityObject == null ? "" : this.securityObject.role;
  }

  getUser(): Promise<UserDetailsResponse> {
    return new Promise((resolve, reject) => {
      this._manager.getUser().then(user => {
        this.securityObject = user;        
        resolve(user)
      });
    });
  }

  getUserDetails(): Promise<UserDetailsResponse> {
    return new Promise((resolve, reject) => {
      if (this.securityObject !== null) {
        resolve(this.securityObject)
      } else {
        this._manager.getUserDetails().then(user => {
          this.securityObject = user;     
          resolve(user)
        });
      }
    });
  }

  startAuthentication(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      window.location.href = AuthService.userManagerSettings.loginUrl;
    });
  }

  logout() {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("userClaims");
    sessionStorage.removeItem("pinLoaded");
    window.location.href = '/Account/Logout';
  }

  private isClaimValid(claimType: string, claimValue?: string): boolean {
    let ret = false;
    let auth: UserDetailsResponse = null;

    auth = this.securityObject;

    if (auth) {
      if (claimType.indexOf(":") >= 0) {
        const words: string[] = claimType.split(":");
        claimType = words[0].toLocaleLowerCase();
        claimValue = words[1];
      } else {
        claimType = claimType.toLocaleLowerCase();
        claimValue = claimValue ? claimValue : "true";
      }

      ret = auth.userClaims.find(
          c =>
            c.claimType.toLocaleLowerCase() === claimType &&
            c.claimValue === claimValue
        ) != null;
    }

    return ret;
  }
}
